/**
 * FinanceScopeNote — shows which units an admin's finance authority covers,
 * so a "that unit is outside your finance scope" 403 is never a mystery.
 */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Globe2, Landmark, ShieldAlert } from 'lucide-react';
import { authHeaders } from '@/lib/authToken';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const FinanceScopeNote = ({ adminId }) => {
  const { data } = useQuery({
    queryKey: ['finance-scope', adminId || 'me'],
    queryFn: async () => {
      const r = await fetch(
        `${API_URL}/api/bank/finance-scope${adminId ? `?admin_id=${adminId}` : ''}`,
        { headers: authHeaders() },
      );
      if (!r.ok) throw new Error('scope unavailable');
      return r.json();
    },
    retry: false,
  });

  if (!data) return null;
  const none = !data.platform_wide && (data.unit_ids || []).length === 0;
  const Icon = data.platform_wide ? Globe2 : none ? ShieldAlert : Landmark;

  return (
    <p
      className={`text-xs flex items-start gap-1.5 ${none ? 'text-amber-600' : 'text-slate-500'}`}
      data-testid="finance-scope-note"
    >
      <Icon className="h-3.5 w-3.5 mt-0.5 shrink-0" />
      <span>
        <span className="font-medium">Finance scope:</span> {data.label}
        {data.finance_roles?.length ? ` · ${data.finance_roles.join(', ')}` : ''}
      </span>
    </p>
  );
};

export default FinanceScopeNote;
